const indexData = [
  { title: '明星八卦', count: '3,256', icon: 'ri-star-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { title: '网红翻车', count: '1,892', icon: 'ri-alert-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { title: '综艺名场面', count: '2,104', icon: 'ri-tv-line', color: 'text-secondary-500', bg: 'bg-secondary-100' },
  { title: '恋爱绯闻', count: '1,678', icon: 'ri-heart-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { title: '合约纠纷', count: '945', icon: 'ri-file-text-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { title: '选秀内幕', count: '1,203', icon: 'ri-mic-line', color: 'text-secondary-500', bg: 'bg-secondary-100' },
  { title: '直播事故', count: '856', icon: 'ri-live-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { title: '资本博弈', count: '734', icon: 'ri-funds-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { title: '海外八卦', count: '1,521', icon: 'ri-global-line', color: 'text-secondary-500', bg: 'bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            主题索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按主题分类浏览，快速找到你感兴趣的八卦类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-4 md:p-5 flex items-center gap-3 md:gap-4 hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 rounded-xl ${item.bg} flex items-center justify-center flex-shrink-0`}>
                <i className={`${item.icon} text-lg ${item.color}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400">{item.count} 条内容</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}